import * as yup from 'yup'

export const societyFAQSectionCreateSchema = yup
  .object({
    section: yup.string().required(),
  })
  .required()
